module.exports = __webpack_public_path__ + "static/media/img1-2.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/K/img1-2.png
// module id = 1931
// module chunks = 3